module.exports = {"username":"demo.petugas_lapangan2","id":"29","group":"pemda","status":"enabled","detil":{"nama":"PetLap Jaktim","nip":"121212121888214237","provinsi_id":"6","provinsi":"DKI Jakarta","kabupaten_id":"44","kabupaten":"Kota Jakarta Timur","kecamatan_id":"472","kecamatan":"Pulo Gadung","kelurahan_id":"4671","kelurahan":"Pisangan Timur","kantor":"Kota Jakarta Timur","kantor_id":"44","kantor_level":"kabupaten"},"roleInfo":{"siroleg":[{"role":"siroleg.pemda.polpp","role_name":"Polpp","name":"siroleg","domains":"siroleg-dist.test","description":"Siroleg","icon":""}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_polpp_jaktim.json
// module id = XvCF
// module chunks = 10